import { createFileRoute } from '@tanstack/react-router';
import { TermsOfService } from '@/features/consumer/terms-of-service';

export const Route = createFileRoute('/(consumer)/_public/terms-of-service')({
  component: TermsOfService,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      embed: (search.embed as string) || undefined,
    };
  },
});
